import { FOOTER_DETAILS } from "../assets/Constants";
import images from "../assets/Images";
import joulezIcon from "../assets/svg/joulezIcon.svg";
import joulezLightIcon from "../assets/svg/JoulezLightIcon.svg";
import facebookIcon from "../assets/svg/facebookIcon.svg";
import facebookLightIcon from "../assets/svg/facebookLightIcon.svg";
import tiktokIcon from "../assets/svg/tiktokIcon.svg";
import tiktokLightIcon from "../assets/svg/tiktokLightIcon.svg";
import youtubeIcon from "../assets/svg/youtubeIcon.svg";
import youtubeLightIcon from "../assets/svg/youtubeLightIcon.svg";
import twitterIcon from "../assets/svg/TwitterNew.svg";
import linkedinIcon from "../assets/svg/linkedinIcon.svg";
import bskyIcon from "../assets/svg/bskyIcon.svg";
import twitterLightIcon from "../assets/svg/twitterLightIcon.svg";
import instaIcon from "../assets/svg/InstaIcon.svg";
import InstaLightIcon from "../assets/svg/InstaLightIcon.svg";
import phoneIcon from "../assets/svg/phoneIcon.svg";
import mailIcon from "../assets/svg/mailIcon.svg";
import officeIcon from "../assets/svg/officeLogo.svg";
//import whatsupMessageLogo from "../assets/svg/whatsupMessageLogo.svg";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const isDarkMode = useSelector((store) => store.currentModeStatus.darkMode);
  const currentPage = useSelector((state) => state?.currentPage?.page);
  const navigate = useNavigate();
  const currentYear = new Date().getFullYear();
  //this is to navigate to specific page and we are passing the state name of ([detail?.name])---> FAQs as true to switch faq tab.
  const handleNavigate = (detail) => {
    navigate(detail?.path, { state: { [detail?.name]: true } });
  };

  return (
    <div
      className={`${
        isDarkMode ? "darkGreyMode" : "lightGreyMode"
      } fontAntarctica p-3 p-lg-5`}
    >
      <div className="container col-12 text-md-start d-flex flex-md-row  flex-column  justify-content-md-between">
        <div className="pt-3 padding40 text-center">
          <img
            src={isDarkMode ? joulezIcon : joulezLightIcon}
            alt="joulezLogo"
          />
          <p className="pt-4 fontSize13">Our Partners</p>
          <img
            className="siriusImg"
            src={isDarkMode ? images?.SiriusImage : images?.SiriusLightImage}
            alt="siriusImage"
          />
        </div>
        <hr className="footerBorder" />
        <div className="d-flex justify-content-start col-lg-3 py-3">
          <div className="px-4">
            {FOOTER_DETAILS?.bookingInfo?.map((detail, index) => (
              <div
                onClick={() => handleNavigate(detail)}
                key={index}
                className="mb-2 fontSize13 hoverUnderLine"
              >
                { detail?.name === "FAQs" && currentPage === "home" ? "" : detail?.name}
              </div>
            ))}
          </div>
          {/* <div className="px-4">
            {FOOTER_DETAILS?.additionalResources?.map((detail, index) => (
              <p
                onClick={() => navigate(`${detail?.path}`)}
                key={index}
                className="mb-2 fontSize13  hoverUnderLine"
              >
                {detail?.name}
              </p>
            ))}
          </div> */}
        </div>
        <hr className="footerBorder" />
        <div className="pt-3 px-4">
          {/* {FOOTER_DETAILS?.officeInfo?.map((detail, index) => (
            <p key={index} className="mb-2 fontSize13 opacity">
              {detail}
            </p>
          ))} */}
          {FOOTER_DETAILS?.officeInfo?.map((detail, index) => (
            <div
              key={index}
              className={`mb-3 fontSize13 ${index === 1 ? "opacity" : ""}`}
            >
              <img src={officeIcon} alt="officeIcon" className="px-1" />
              <span>{detail?.addressLine1} </span>
              <br />
              <span className="mx-4">{detail?.addressLine2}</span>
            </div>
          ))}

          <div className="fontSize13 mb-3">
            <img src={phoneIcon} alt="phoneIcon" className="px-1" />
            {/* +1<span className=" mx-1 ">(917) 831-4031</span> */}
            <a
              href="tel:+14452568539"
              className="text-white text-decoration-none"
            >
              {" "}
              {/* +1 (917) 831-4031 */}
              {/* +1 (445) 2JOULEZ */}
              +1 (445) 256-8539
            </a>
          </div>
          {/* <div>
            <img src={mailIcon} alt="mailIcon" className="px-1" />
            <span className="fontSize13">Info@drivejoulez.com</span>
          </div> */}
          <div className="mt-2">
            <a
              className="text-white text-decoration-none"
              href="mailto:info@drivejoulez.com"
            >
              <img src={mailIcon} alt="mailIcon" className="px-1" />
              <span className="fontSize13 ">info@drivejoulez.com</span>
            </a>
          </div>
          {/* <div className="fontSize13 mt-2">
            <a
              href="https://wa.me/+14452568539"
              target="_blank" // Open in a new tab
              rel="noopener noreferrer" // For security
            >
              <img
                src={whatsupMessageLogo}
                alt="whatsupMessageLogo"
                className="px-1"
              />
            </a>
          </div> */}
        </div>
      </div>
      <div className="mt-4 mb-3">
        <hr className="footerBorder" />
      </div>
      <div className="d-flex justify-content-between align-items-center ">
        <div className="d-flex flex-sm-row flex-column  justify-content-between w-100">
        <div className="d-flex justify-content-between align-items-center cursorPointer mb-4 order-2">
            <a
              href="https://www.facebook.com/drivejoulez"
              target="_blank"
              rel="noopener noreferrer"
              className="social-link w-inline-block"
            >
              <img
                src={`${isDarkMode ? facebookIcon : facebookLightIcon}`}
                alt="facebookIcon"
                className="px-2 footerLogosHeight"
              />
            </a>
            <div>
              <a
                href="https://www.youtube.com/channel/UC3qvv3Og5Ca-YFg43wSxKAA"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link w-inline-block"
              >
                <img
                  src={`${isDarkMode ? youtubeIcon : youtubeLightIcon}`}
                  alt="youtubeIcon"
                  className="px-2 footerLogosHeight"
                />
              </a>
            </div>
            <div>
              <a
                href="https://www.instagram.com/drivejoulez/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link w-inline-block"
              >
                <img
                  src={`${isDarkMode ? instaIcon : InstaLightIcon}`}
                  alt="instaIcon"
                  className="px-2 footerLogosHeight"
                />
              </a>
            </div>
            <div>
              <a
                href="https://twitter.com/drivejoulez"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link w-inline-block"
              >
                <img
                  src={`${isDarkMode ? twitterIcon : twitterLightIcon}`}
                  alt="twitterIcon"
                  className="px-2 footerLogosHeight"
                />
              </a>
            </div>
            <div>
              <a
                href="https://tiktok.com/@drivejoulez"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link w-inline-block"
              >
                <img
                  src={`${isDarkMode ? tiktokIcon : tiktokLightIcon}`}
                  alt="tiktokIcon"
                  className="px-2 footerLogosHeight"
                />
              </a>
            </div>
            <div>
              <a
                href="https://www.linkedin.com/company/drivejoulez/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link w-inline-block"
              >
                <img
                  src={`${linkedinIcon}`}
                  alt="linkedinIcon"
                  className="px-2 height25"
                />
              </a>
            </div>
            <div>
              <a
                href="https://bsky.app/profile/drivejoulez.bsky.social"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link w-inline-block"
              >
                <img
                  src={`${bskyIcon}`}
                  alt="tiktokIcon"
                  className="px-2 footerLogosHeight"
                />
              </a>
            </div>
          </div>
          <div className="order-3 order-lg-1 d-flex justify-content-between align-items-center flex-wrap flex-sm-nowrap flex-md-nowrap flex-lg-nowrap cursorPointer">
            {FOOTER_DETAILS?.termsAndConditions?.map((detail, index) => (
              <p
                onClick={() => navigate(`${detail?.path}`)}
                key={index}
                className="px-2 fontSize16 fontColorCE1"
              >
                {detail?.name}
              </p>
            ))}
          </div>
        </div>
      </div>
      <div className="mt-4 mt-sm-0 mt-md-0 mt-lg-0 text-center text-sm-start text-md-start  text-lg-start ">
        <small className="px-1 fontAntarctica fontSize13">
          &#169; {currentYear} Joulez Inc., All Rights Reserved.
        </small>
      </div>
    </div>
  );
};

export default Footer;
